import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useIsLoggedIn } from "@/hooks/useIsLoggedIn";
import { allLangs, defaultLang } from "@/locales/configLang";
import { setLanguage } from "@/locales/i18n";
import { updateUserRequest } from "@/services/authService";

export const useLocales = () => {
  const { i18n, t } = useTranslation();
  const isLoggedIn = useIsLoggedIn();

  const currentLang = allLangs.find((lang) => lang.value === i18n.language) || defaultLang;

  const onChangeLang = useCallback(
    (newLang: string) => {
      void setLanguage(newLang).then((code) => {
        // Emails and the Telegram bot read the language from the profile.
        if (isLoggedIn) updateUserRequest({ language: code }).catch(() => undefined);
      });
    },
    [isLoggedIn],
  );

  return {
    allLangs,
    t,
    currentLang,
    onChangeLang,
  };
};
